import { IEventLogItem, EventLogItem } from "./eventLogItem";

export interface IEventLogItems {
    items: IEventLogItem[];
    hasMore: boolean;
    page: number;
}

export class EventLogItems implements IEventLogItems {
    items: EventLogItem[];
    hasMore: boolean;
    page: number;

    constructor();
    constructor(obj: IEventLogItems);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = [];
        if (obj && obj.items) {
            for (let i = 0; i < obj.items.length; i++) {
                this.items.push(new EventLogItem(obj.items[i]));
            }
        }
    }
}